define('app/views/customer_profile_invite_friend',['app/setup'],
  function (takhfifan) {

    takhfifan.CustomerProfileInviteFriendView = Backbone.View.extend({

      el: $('.tkh-profile-invite-friend'),

      events: {
        'click .tkh-profile-invite-friend-get-code': 'getReferrerCode',
        'click .tkh-profile-invite-friend-copy-code': 'copyCode'
      },

      initialize: function (options) {
        var _this = this;

        this.codeWrapper = this.$el.find('.tkh-profile-invite-friend-code-wrapper');
        this.shareWrapper = this.$el.find('.tkh-profile-invite-friend-share-box');

        this.formKey = takhfifan.formKey;
        takhfifan.eventHub.on('formkey', function (formKey) {
          _this.formKey = formKey;
        }, this);
      },

      getReferrerCode: function (e) {
        var _this = this;

        if(!this.formKey){
          this.getAndSetFormKey('getReferrerCode');
          return;
        }

        $.ajax({
          url: '/ajax/account/getReferralDiscountCode',
          type: 'post',
          data: {
            form_key: _this.formKey,
            ajax : true
          }
        }).done(function (data) {
          if (data && data.success && data.message && data.message.code) {
            _this.codebox = _this.$el.find('.tkh-profile-invite-friend-code').first();
            _this.shareText = _this.$el.find('.tkh-profile-invite-friend-share-text').first();

            _this.$el.find('.tkh-profile-invite-friend-get-code').hide();
            _this.codebox.val(data.message.code);
            _this.shareText.text(_this.shareText.val() + data.message.code);
            _this.codeWrapper.css("visibility", "visible");
            _this.shareWrapper.css("display", "block");

          } else {
            takhfifan.eventHub.trigger('message:show', {
              type: 'error',
              msg: "متاسفانه کد به درستی دریافت نشد"
            });
          }
        }).fail(function (data, textStatus, errorThrown) {
          var message = 'متاسفانه کد به درستی دریافت نشد';
          if (data && data.status) {
            switch (data.status) {
              case 403 :
                message += 'شما مجاز به انجام این عملیات نمی باشید';
                break;
              case 405 :
                message += 'لطفا مجدد به سایت وارد شوید';
                break;
              case 423 :
                message += 'در حال حاضر این امکان غیر فعال می باشد';
                break;
              case 590 :
                message = 'متاسفانه کد به درستی ساخته نشد. لطفا مجدد تلاش نمایید.';
                break;
              case 591 :
                message = 'متاسفانه اطلاعات شما به درستی ثبت نشد. لطفا مجدد تلاش نمایید.';
                break;
            }
          }
          takhfifan.eventHub.trigger('message:show', {
            type: 'error',
            msg: message
          });
        });
      },

      copyCode: function () {
        this.shareText.css("display", "inline-block");
        this.shareText.select();
        document.execCommand("copy");
        this.shareText.css("display", "none");
        this.codebox.select();
      },

      getAndSetFormKey: function (successCallback) {
        var _this = this;

        $.ajax({
          url: '/ajax/account/session',
          type: 'GET',
          dataType: 'json',
          success: function (data) {
            if (data && data.formKey) {
              window.formKey = _this.formKey = data.formKey;
            }
            if (successCallback) {
              _this[successCallback]();
            }
          },
          error: function (error) {
            takhfifan.eventHub.trigger('message:show', {
              type: 'error',
              msg: "متاسفانه ارتباط شما قطع می باشد. لطفا صفحه را مجدد بارگیری نمایید."
            });
            console.error("getSession error: ", error);
          }
        })
      }
    });
  });
